import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { listTab } from './configs';
import useActiveTab from '@wolffun/shared/src/hooks/useActiveTab';

const MarketTabs = ({
  className,
  currentTab,
  onTabChanged
}) => {
  const {
    lineRef,
    refs
  } = useActiveTab({
    selectedKey: currentTab,
    data: listTab,
    onFilter: item => item.key === currentTab
  });

  const renderButton = (data, index) => {
    const {
      name,
      icon,
      key
    } = data;
    const active = !currentTab || key === currentTab;
    return /*#__PURE__*/React.createElement("div", {
      onClick: () => {
        onTabChanged === null || onTabChanged === void 0 ? void 0 : onTabChanged(key);
      },
      key: key,
      className: styles.wrapBtn,
      ref: ref => {
        if (ref) {
          refs.current[index] = ref;
        }
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: classNames(styles.btn, active && styles.active)
    }, /*#__PURE__*/React.createElement("img", {
      draggable: false,
      className: styles.icon,
      src: icon
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.txt
    }, name)));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(className, styles.container)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.groupBtn
  }, listTab.map((tab, index) => renderButton(tab, index)), /*#__PURE__*/React.createElement("div", {
    className: styles.btnLine,
    ref: lineRef
  })));
};

export default MarketTabs;